import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/genesis_build_front_genesis_main/apps/site-shop/app/global-error.tsx");
